// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4c-6";
export var headerCell = "_4c-2";
export var rowWrapper = "_4c-4";
export var stickyAggregationCell = "_4c-a";
export var stickyAggregationRow = "_4c-7";
export var stickyColumnCell = "_4c-9";
export var stickyColumnHeaderCell = "_4c-8";
export var table = "_4c-1";
export var virtualRowWrapper = "_4c-5";
export var virtualTableContainer = "_4c-0";
export var white = "_4c-3";